import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.number.parse-float";
import "core-js/modules/es6.number.constructor";
import { buryingPoint } from "@/util/buryingPoint";
import { goToHome } from '@ykz/ykz-util/platform';
export default {
  name: 'sameRecommend',
  props: {
    sameRecommendList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isPromoter: Number,
    kv: Object
  },
  data: function data() {
    return {
      isAPP: window.mobileEnv == "app" ? true : false,
      //是否在云客赞app打开页面
      fxbInviteCode: getUrlParams('fxbInviteCode') || ""
    };
  },
  filters: {
    priceFormat: function priceFormat(val) {
      return Number.parseFloat(val).toFixed(1);
    }
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    window.componentCenter.sameRecommend = this;
    console.log("ycf组件初始化：sameRecommend");
  },
  methods: {
    // 查看更多到首页
    goHome: function goHome() {
      var weChatId = sessionStorage.getItem('weChatId') || '';
      if (this.fxbInviteCode) {
        window.location.href = "/front/promoter/fxbIndex?&weChatId=1&fromWeChatId=" + weChatId;
      } else {
        // window.location.href = "/front/promoter/shoppingMallv2?weChatId=1&fromWeChatId=" + weChatId;
        var url = "/front/promoter/shoppingMallv2?weChatId=1&fromWeChatId=" + weChatId;
        goToHome(url);
      }
      ;
      YCF_Plugin.anchorPoint("同类推荐", "similar_recommend", '');
    },
    goDetail: function goDetail(product) {
      buryingPoint('SXY-DJTLXTJ', '点击同类型推荐', this.kv);
      window.location.href = product.linkUrl;
      YCF_Plugin.anchorPoint("同类推荐", "similar_recommend", "\u540C\u7C7B\u63A8\u8350\u94FE\u63A5\uFF1A".concat(product.linkUrl));
    }
  }
};